// =============================================================================
// src/data/manaus-fiscal.ts — Dados do Impostometro (ICMS / ISS · Tela 11).
//
// Proveniencia: assets/unified-app.js DATA.fiscal (linhas 206-247). Portado
//   verbatim. `arrec`/`retorno` em milhoes de R$ por zona; `yoyClass` controla
//   a cor da seta (up/down). Anos 2020-2025, sendo 2025 projecao parcial.
// =============================================================================

// Reforma 2026-06 (F4): yoy SEM seta unicode embutida — a direcao vive em
// yoyClass e o renderer aplica icone Tabler (yoyDeltaHtml em impostometro-view).
import type { FiscalData } from '../app/types';

/** Serie fiscal completa por imposto (DATA.fiscal): ICMS e ISS, 2020-2025. */
export const MANAUS_FISCAL: FiscalData = {
  icms: {
    2020: {
      total: 'R$ 5,8 bi', perCapita: 'R$ 2.640', yoy: '3,1% vs 2019', yoyClass: 'down',
      desc: 'ICMS — imposto sobre circulação de mercadorias', note: 'exercício completo',
      arrec: { norte: 620, leste: 1020, 'centro-oeste': 840, 'centro-sul': 1980, oeste: 410, sul: 1520 },
      retorno: { norte: 1080, leste: 780, 'centro-oeste': 590, 'centro-sul': 1320, oeste: 1180, sul: 720 },
    },
    2021: {
      total: 'R$ 6,3 bi', perCapita: 'R$ 2.850', yoy: '8,6% vs 2020', yoyClass: 'up',
      desc: 'ICMS — imposto sobre circulação de mercadorias', note: 'exercício completo',
      arrec: { norte: 660, leste: 1080, 'centro-oeste': 890, 'centro-sul': 2080, oeste: 440, sul: 1590 },
      retorno: { norte: 1140, leste: 820, 'centro-oeste': 620, 'centro-sul': 1380, oeste: 1250, sul: 760 },
    },
    2022: {
      total: 'R$ 7,1 bi', perCapita: 'R$ 3.180', yoy: '12,7% vs 2021', yoyClass: 'up',
      desc: 'ICMS — imposto sobre circulação de mercadorias', note: 'exercício completo',
      arrec: { norte: 710, leste: 1160, 'centro-oeste': 950, 'centro-sul': 2200, oeste: 480, sul: 1680 },
      retorno: { norte: 1220, leste: 870, 'centro-oeste': 660, 'centro-sul': 1450, oeste: 1330, sul: 800 },
    },
    2023: {
      total: 'R$ 7,6 bi', perCapita: 'R$ 3.380', yoy: '7,0% vs 2022', yoyClass: 'up',
      desc: 'ICMS — imposto sobre circulação de mercadorias', note: 'exercício completo',
      arrec: { norte: 750, leste: 1220, 'centro-oeste': 990, 'centro-sul': 2300, oeste: 520, sul: 1750 },
      retorno: { norte: 1300, leste: 920, 'centro-oeste': 700, 'centro-sul': 1530, oeste: 1400, sul: 850 },
    },
    2024: {
      total: 'R$ 7,9 bi', perCapita: 'R$ 3.510', yoy: '3,9% vs 2023', yoyClass: 'up',
      desc: 'ICMS — imposto sobre circulação de mercadorias', note: 'exercício completo',
      arrec: { norte: 780, leste: 1280, 'centro-oeste': 1030, 'centro-sul': 2380, oeste: 550, sul: 1810 },
      retorno: { norte: 1360, leste: 950, 'centro-oeste': 730, 'centro-sul': 1600, oeste: 1470, sul: 880 },
    },
    2025: {
      total: 'R$ 8,4 bi', perCapita: 'R$ 3.720', yoy: '6,2% vs 2024', yoyClass: 'up',
      desc: 'ICMS — imposto sobre circulação de mercadorias', note: 'dados até mai/2025 · projeção anual',
      arrec: { norte: 820, leste: 1340, 'centro-oeste': 1080, 'centro-sul': 2450, oeste: 580, sul: 1890 },
      retorno: { norte: 1420, leste: 980, 'centro-oeste': 760, 'centro-sul': 1680, oeste: 1540, sul: 920 },
    },
  },
  iss: {
    2020: {
      total: 'R$ 1,1 bi', perCapita: 'R$ 490', yoy: '5,8% vs 2019', yoyClass: 'down',
      desc: 'ISS — imposto sobre serviços', note: 'exercício completo',
      arrec: { norte: 180, leste: 420, 'centro-oeste': 340, 'centro-sul': 920, oeste: 120, sul: 680 },
      retorno: { norte: 510, leste: 360, 'centro-oeste': 280, 'centro-sul': 580, oeste: 480, sul: 340 },
    },
    2021: {
      total: 'R$ 1,2 bi', perCapita: 'R$ 540', yoy: '10,2% vs 2020', yoyClass: 'up',
      desc: 'ISS — imposto sobre serviços', note: 'exercício completo',
      arrec: { norte: 200, leste: 460, 'centro-oeste': 370, 'centro-sul': 990, oeste: 140, sul: 730 },
      retorno: { norte: 540, leste: 380, 'centro-oeste': 300, 'centro-sul': 620, oeste: 510, sul: 360 },
    },
    2022: {
      total: 'R$ 1,4 bi', perCapita: 'R$ 620', yoy: '14,8% vs 2021', yoyClass: 'up',
      desc: 'ISS — imposto sobre serviços', note: 'exercício completo',
      arrec: { norte: 230, leste: 510, 'centro-oeste': 400, 'centro-sul': 1080, oeste: 160, sul: 790 },
      retorno: { norte: 580, leste: 410, 'centro-oeste': 320, 'centro-sul': 670, oeste: 550, sul: 390 },
    },
    2023: {
      total: 'R$ 1,6 bi', perCapita: 'R$ 700', yoy: '12,9% vs 2022', yoyClass: 'up',
      desc: 'ISS — imposto sobre serviços', note: 'exercício completo',
      arrec: { norte: 260, leste: 560, 'centro-oeste': 440, 'centro-sul': 1160, oeste: 180, sul: 850 },
      retorno: { norte: 620, leste: 440, 'centro-oeste': 350, 'centro-sul': 720, oeste: 590, sul: 420 },
    },
    2024: {
      total: 'R$ 1,8 bi', perCapita: 'R$ 790', yoy: '12,9% vs 2023', yoyClass: 'up',
      desc: 'ISS — imposto sobre serviços', note: 'exercício completo',
      arrec: { norte: 290, leste: 610, 'centro-oeste': 480, 'centro-sul': 1240, oeste: 200, sul: 920 },
      retorno: { norte: 660, leste: 470, 'centro-oeste': 380, 'centro-sul': 770, oeste: 630, sul: 450 },
    },
    2025: {
      total: 'R$ 2,0 bi', perCapita: 'R$ 880', yoy: '11,4% vs 2024', yoyClass: 'up',
      desc: 'ISS — imposto sobre serviços', note: 'dados até mai/2025 · projeção anual',
      arrec: { norte: 320, leste: 670, 'centro-oeste': 520, 'centro-sul': 1340, oeste: 220, sul: 990 },
      retorno: { norte: 700, leste: 500, 'centro-oeste': 410, 'centro-sul': 830, oeste: 670, sul: 480 },
    },
  },
};
